import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

// You should put logos in the public/images folder, e.g., /images/docker.png
const tools = [
  {
    name: "Linux",
    desc: "Open-source operating system widely used in DevOps environments.",
    logo: "/images/linux.png",
  },
  {
    name: "Bash Scripting",
    desc: "Command-line scripting for automating tasks in Unix/Linux systems.",
    logo: "/images/bash.png",
  },
  {
    name: "Git",
    desc: "Version control system to track code changes and collaborate efficiently.",
    logo: "/images/github.png",
  },
  {
    name: "Jenkins",
    desc: "Automation server for building CI/CD pipelines efficiently.",
    logo: "/images/Jenkins.png",
  },
  {
    name: "AWS",
    desc: "Cloud platform providing scalable infrastructure and services.",
    logo: "/images/Aws.png",
  },
  {
    name: "Docker",
    desc: "Containerization platform to build, ship, and run applications in isolated environments.",
    logo: "/images/docker.png",
  },
  {
    name: "Kubernetes",
    desc: "Orchestration tool for automating deployment, scaling, and management of containerized apps.",
    logo: "/images/Kubernetes.svg",
  },
  {
    name: "Terraform",
    desc: "Infrastructure-as-Code tool to provision and manage cloud resources.",
    logo: "/images/terraform.png",
  },
  {
    name: "Helm",
    desc: "Package manager for Kubernetes to define, install, and upgrade applications.",
    logo: "/images/helm.png",
  },
  {
    name: "Ansible",
    desc: "Automation tool for configuration management, application deployment, and orchestration.",
    logo: "/images/ansible.png",
  },
  {
    name: "Prometheus",
    desc: "Monitoring and alerting toolkit for cloud-native environments.",
    logo: "/images/prometheus.png",
  },
  {
    name: "Grafana",
    desc: "Visualization tool to create dashboards from metrics collected by Prometheus or other sources.",
    logo: "/images/grafana.png",
  },
  {
    name: "Argo CD",
    desc: "Declarative, GitOps continuous delivery tool for Kubernetes to automate application deployments.",
    logo: "/images/argocd.png",
  },
  {
    name: "JFrog Artifactory",
    desc: "Universal artifact repository manager to store and manage build artifacts and dependencies.",
    logo: "/images/jfrog.png",
  },
  {
    name: "SonarQube",
    desc: "Continuous code quality inspection tool to detect bugs, vulnerabilities and code smells.",
    logo: "/images/sonarqube.png",
  },
];

const DevOps = () => {
  return (
    <Container className="my-5">
      <h2 className="mb-4 text-center">DevOps Tools</h2>
      <Row className="g-4">
        {tools.map((tool, index) => (
          <Col key={index} xs={12} sm={6} md={4} lg={3}>
            <Card className="h-100 shadow-sm text-center p-3">
              {tool.logo && (
                <Card.Img
                  variant="top"
                  src={tool.logo}
                  alt={tool.name}
                  style={{ width: "80px", height: "80px", objectFit: "contain", margin: "0 auto" }}
                  className="mb-3"
                />
              )}
              <Card.Body>
                <Card.Title>{tool.name}</Card.Title>
                <Card.Text>{tool.desc}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default DevOps;
